import React from "react";
import Navigation from "../Common/Navigation";
import { NavLink } from "react-router-dom";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logo: require("./../../images/logo/logo_icon.png"),
      logo_name: require("./../../images/logo/logo_name.png"),
    };
  }

  state = { isSearchActive: false, isQuoteActive: false };

  handleSearchToggle = () => {
    this.setState({ isSearchActive: !this.state.isSearchActive });
  };

  handleQuoteToggle = () => {
    this.setState({ isQuoteActive: !this.state.isQuoteActive });
  };

  componentDidMount() {
    const handleScroll = () => {
      const offset = window.scrollY;

      const stickyheader = document.querySelector(".sticky-header ");

      if (offset >= 100) {
        stickyheader.classList.add("is-fixed");
        stickyheader.classList.add("color-fill");
      } else {
        stickyheader.classList.remove("is-fixed");
        stickyheader.classList.remove("color-fill");
      }
    };

    window.addEventListener("scroll", handleScroll);

    window.updateTopMostParent = (logopath) => {
      this.setState({ logo: logopath });
    };
  }

  render() {
    return (
      <>
        <header className="site-header header-style-1">
          <div className="top-bar bg-gray">
            <div className="container">
              <div className="row">
                <div className="mt-topbar-left clearfix">
                  <ul className="list-unstyled e-p-bx pull-right">
                    <li>
                      <i className="fa fa-envelope" /> jit.services13@gmail.com
                    </li>
                    <li>
                      <i className="fa fa-phone" />v +91 90478 85552
                    </li>
                    <li>
                      <i className="fa fa-map-pin" />
                      Woraiyur Main Road, Trichy - 620003
                    </li>
                  </ul>
                </div>
                <div className="mt-topbar-right clearfix">
                  <div className="appint-btn">
                    <NavLink to={"/contact"} className="site-button">
                      Get In Touch
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sticky-header main-bar-wraper">
            <div className="main-bar bg-white">
              <div className="logo-container">
                <div className="logo-header">
                  <div className="logo-header-inner logo-header-one">
                    <NavLink to={"./"}>
                      <img src={this.state.logo} alt="Shapen" />
                    </NavLink>
                  </div>
                </div>

                <div className="logo-center">
                  <NavLink to={"./"}>
                    <img src={this.state.logo_name} alt="Shapen" />
                  </NavLink>
                </div>
                {/* NAV Toggle Button */}
                <button
                  data-target=".header-nav"
                  data-toggle="collapse"
                  type="button"
                  className="navbar-toggle collapsed"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>

                {/* MAIN Vav */}
                <Navigation />
              </div>
            </div>
          </div>
        </header>
      </>
    );
  }
}

export default Header;
